<page-loader *ngIf="!isloaded"></page-loader>
<div *ngIf="isloaded">
    <div class="table-responsive">
        <!--
            The table (and therefore the filter inputs) stays mounted while a
            request is in flight. Swapping it for a loader destroyed the input the
            admin was typing in and dropped their cursor on every keystroke.
        -->
        <table class="table user-table associations-table" [class.is-filtering]="isFiltering">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Counselor</th>
                    <th class="organization-col">Organization</th>
                    <th>Confirmed</th>
                    <th class="actions-col"></th>
                </tr>
                <tr class="filter-row">
                    <th>
                        <input class="filter-control" type="text" placeholder="Filter..."
                            [(ngModel)]="userEmail" (input)="onFilterChange()" />
                    </th>
                    <th>
                        <input class="filter-control" type="text" placeholder="Filter..."
                            [(ngModel)]="counselorEmail" (input)="onFilterChange()" />
                    </th>
                    <th>
                        <select class="filter-control"
                            [(ngModel)]="organizationIds" (change)="onFilterChange()">
                            <option [value]="null">All</option>
                            <option *ngFor="let organization of organizations" [value]="organization.id">
                                {{ organization.name }}
                            </option>
                        </select>
                    </th>
                    <th>
                        <select class="filter-control"
                            [(ngModel)]="confirmedFilter" (change)="onFilterChange()">
                            <option value="">All</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </th>
                    <th class="actions-col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let association of associations">
                    <td>
                        <a class="user-link" [routerLink]="['/admin/user', association.userId]">
                            {{ association.userEmail }}
                        </a>
                    </td>
                    <td>
                        <a class="user-link" [routerLink]="['/admin/user', association.counselorId]">
                            {{ association.counselorEmail }}
                        </a>
                    </td>
                    <td class="organization-col">{{ association.organizationName }}</td>
                    <td>
                        <span class="status-badge"
                            [ngClass]="association.Confirmed ? 'status-approved' : 'status-unconfirmed'">
                            {{ association.Confirmed ? 'Yes' : 'No' }}
                        </span>
                    </td>
                    <td class="actions-col">
                        <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                            *ngIf="!association.Confirmed"
                            (click)="onApprove(association.id)" title="Approve">
                            <svg-icon icon="unlock-circle" class="w-100 h-100"></svg-icon>
                        </button>
                        <button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20 delete-btn"
                            (click)="onRemove(association.id)" title="Remove">
                            <svg-icon icon="trash" class="w-100 h-100"></svg-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <p *ngIf="isFiltering" class="filtering-note">Filtering&hellip;</p>
        <p *ngIf="!isFiltering && (!associations || associations.length === 0)" class="empty-state">
            No associations found.
        </p>
    </div>
</div>
